import apiService from './ApiService';

class AreaService {
  async getAreas(idColegio = null, options = {}) {
    const params = new URLSearchParams();
    if (idColegio) params.append('idColegio', idColegio);
    if (options.start !== undefined && options.start !== null) params.append('start', options.start);
    if (options.end !== undefined && options.end !== null) params.append('end', options.end);
    const qs = params.toString();
    const endpoint = `/area${qs ? `?${qs}` : ''}`;
    const response = await apiService.get(endpoint);
    const areas = response?.areas || response?.Areas || response?.data || response || [];
    const items = Array.isArray(areas) ? areas : [];
    const total = response?.total ?? response?.Total ?? items.length;
    if (options.includeTotal || options.start !== undefined || options.end !== undefined) {
      return { items, total };
    }
    return items;
  }

  async getAreasActivas(idColegio = null, options = {}) {
    const params = new URLSearchParams();
    if (idColegio) params.append('idColegio', idColegio);
    if (options.start !== undefined && options.start !== null) params.append('start', options.start);
    if (options.end !== undefined && options.end !== null) params.append('end', options.end);
    const qs = params.toString();
    const endpoint = `/area/activos${qs ? `?${qs}` : ''}`;
    const response = await apiService.get(endpoint);
    const areas = response?.areas || response?.Areas || response?.data || response || [];
    const items = Array.isArray(areas) ? areas : [];
    const total = response?.total ?? response?.Total ?? items.length;
    if (options.includeTotal || options.start !== undefined || options.end !== undefined) {
      return { items, total };
    }
    return items;
  }

  async getAreaById(id) {
    const response = await apiService.get(`/area/${id}`);
    const list = response?.areas || response?.Areas || [];
    return Array.isArray(list) && list.length > 0 ? list[0] : response;
  }

  async createArea(payload) {
    const response = await apiService.post('/area', payload);
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos crear el área.';
      throw new Error(msg);
    }
    return response;
  }

  async updateArea(id, payload) {
    const response = await apiService.put(`/area/${id}`, payload);
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos actualizar el área.';
      throw new Error(msg);
    }
    return response;
  }

  async updateAreaActivo(id, activo) {
    const response = await apiService.put(`/area/${id}/activo`, { activo });
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos actualizar el estado del área.';
      throw new Error(msg);
    }
    return response;
  }

  async assignAdmins(idArea, adminIds = []) {
    if (!idArea) {
      throw new Error('Falta el área a la que se deben asociar los admins.');
    }
    if (!Array.isArray(adminIds) || adminIds.length === 0) {
      throw new Error('Selecciona al menos un admin de área para asociar.');
    }

    const response = await apiService.post('/area/admins', { idArea, adminIds });

    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos asociar los admins al área.';
      throw new Error(msg);
    }

    return response;
  }
}

const areaService = new AreaService();

export default areaService;
